export var IS_FOCUSABLE_ATTRIBUTE = 'data-is-focusable';
export var IS_ENTER_DISABLED_ATTRIBUTE = 'data-disable-click-on-enter';